export class ApiError extends Error {
    status: number

    constructor(message: string, status: number) {
        super(message)
        this.name = 'ApiError'
        this.status = status
    }
}

interface RequestOptions {
    method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
    body?: unknown
}

export const apiRequest = async <T = unknown>(url: string, options: RequestOptions = {}): Promise<T> => {
    let response: Response

    try {
        response = await fetch(url, {
            method: options.method ?? (options.body === undefined ? 'GET' : 'POST'),
            headers: options.body === undefined ? undefined : { 'Content-Type': 'application/json' },
            body: options.body === undefined ? undefined : JSON.stringify(options.body),
            credentials: 'same-origin'
        })
    }
    catch {
        throw new ApiError('Geen verbinding. Controleer uw internet en probeer het opnieuw.', 0)
    }

    let data: unknown = null

    try {
        data = await response.json()
    }
    catch {
        data = null
    }

    if (!response.ok) {
        const message = data && typeof data === 'object' && 'error' in data && typeof (data as { error: unknown }).error === 'string'
            ? (data as { error: string }).error
            : 'Er ging iets mis. Probeer het opnieuw.'

        throw new ApiError(message, response.status)
    }

    return data as T
}

export const errorMessage = (error: unknown): string => {
    if (error instanceof Error && error.message) return error.message

    return 'Er ging iets mis. Probeer het opnieuw.'
}
